import type { FleetUser } from 'src/api/endpoints/cloudEnterprise.types';

export function getFullName(user?: FleetUser) {
  if (!user) return '';

  const firstName = user.firstName ?? '';
  const lastName = user.lastName ?? '';
  return [firstName, lastName].filter(Boolean).join(' ');
}
